export default __webpack_public_path__ + "static/media/Dvorkovich_Arkady_Vladimirovich.2ec13dfc.webp";